/**
 * 业务相关枚举常量定义
 */

// 业务类型枚举
export enum BusinessType {
  /** 未定义 */
  NULL = -1,
  /** 个贷押品业务 */
  PERSONAL_LOAN_BUSINESS = 1001,
  /** 对公押品业务 */
  PUBLIC_COLLATERAL_BUSINESS = 1002,
  /** 普惠押品业务 */
  INCLUSIVE_COLLATERAL_BUSINESS = 1003,
  /** 租赁业务 */
  LEASING_BUSINESS = 1004,
  /** 其他业务 */
  OTHER_BUSINESS = 1005,
  /** 司法评估业务 */
  JUDICIAL_APPRAISAL_BUSINESS = 1006,
  /** 对公押品业务 */
  PUBLIC_ASSET_BUSINESS = 2001,
  /** 普惠押品业务 */
  INCLUSIVE_ASSET_BUSINESS = 2002,
  /** 个贷押品业务 */
  PERSONAL_ASSET_BUSINESS = 2003,
  /** 租赁业务 */
  LEASING_ASSET_BUSINESS = 2004,
  /** 司法评估业务 */
  JUDICIAL_ASSET_BUSINESS = 2005,
  /** 企业整体评估 */
  ENTERPRISE_OVERALL_ASSESSMENT = 2006,
  /** 金融不良资产业务 */
  FINANCIAL_DISTRESSED_ASSET_BUSINESS = 2007,
  /** 其他业务 */
  OTHER_ASSET_BUSINESS = 2008,
}

// 业务类型显示名称映射
export const BusinessTypeNames: Record<number, string> = {
  [BusinessType.NULL]: '未定义',
  [BusinessType.PERSONAL_LOAN_BUSINESS]: '个贷押品业务',
  [BusinessType.PUBLIC_COLLATERAL_BUSINESS]: '对公押品业务',
  [BusinessType.INCLUSIVE_COLLATERAL_BUSINESS]: '普惠押品业务',
  [BusinessType.LEASING_BUSINESS]: '租赁业务',
  [BusinessType.OTHER_BUSINESS]: '其他业务',
  [BusinessType.JUDICIAL_APPRAISAL_BUSINESS]: '司法评估业务',
  [BusinessType.PUBLIC_ASSET_BUSINESS]: '对公押品业务',
  [BusinessType.INCLUSIVE_ASSET_BUSINESS]: '普惠押品业务',
  [BusinessType.PERSONAL_ASSET_BUSINESS]: '个贷押品业务',
  [BusinessType.LEASING_ASSET_BUSINESS]: '租赁业务',
  [BusinessType.JUDICIAL_ASSET_BUSINESS]: '司法评估业务',
  [BusinessType.ENTERPRISE_OVERALL_ASSESSMENT]: '企业整体评估',
  [BusinessType.FINANCIAL_DISTRESSED_ASSET_BUSINESS]: '金融不良资产业务',
  [BusinessType.OTHER_ASSET_BUSINESS]: '其他业务',
};

// 业务类型选项（用于下拉选择）
export const BusinessTypeOptions = [
  { value: BusinessType.PERSONAL_LOAN_BUSINESS, label: BusinessTypeNames[BusinessType.PERSONAL_LOAN_BUSINESS] },
  { value: BusinessType.PUBLIC_COLLATERAL_BUSINESS, label: BusinessTypeNames[BusinessType.PUBLIC_COLLATERAL_BUSINESS] },
  { value: BusinessType.INCLUSIVE_COLLATERAL_BUSINESS, label: BusinessTypeNames[BusinessType.INCLUSIVE_COLLATERAL_BUSINESS] },
  { value: BusinessType.LEASING_BUSINESS, label: BusinessTypeNames[BusinessType.LEASING_BUSINESS] },
  { value: BusinessType.OTHER_BUSINESS, label: BusinessTypeNames[BusinessType.OTHER_BUSINESS] },
  { value: BusinessType.JUDICIAL_APPRAISAL_BUSINESS, label: BusinessTypeNames[BusinessType.JUDICIAL_APPRAISAL_BUSINESS] },
  { value: BusinessType.PUBLIC_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.PUBLIC_ASSET_BUSINESS] },
  { value: BusinessType.INCLUSIVE_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.INCLUSIVE_ASSET_BUSINESS] },
  { value: BusinessType.PERSONAL_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.PERSONAL_ASSET_BUSINESS] },
  { value: BusinessType.LEASING_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.LEASING_ASSET_BUSINESS] },
  { value: BusinessType.JUDICIAL_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.JUDICIAL_ASSET_BUSINESS] },
  { value: BusinessType.ENTERPRISE_OVERALL_ASSESSMENT, label: BusinessTypeNames[BusinessType.ENTERPRISE_OVERALL_ASSESSMENT] },
  { value: BusinessType.FINANCIAL_DISTRESSED_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.FINANCIAL_DISTRESSED_ASSET_BUSINESS] },
  { value: BusinessType.OTHER_ASSET_BUSINESS, label: BusinessTypeNames[BusinessType.OTHER_ASSET_BUSINESS] },
];

// 业务领域枚举
export enum BusinessLines {
  /** 未定义 */
  NULL = -1,
  /** 房地产及土地评估 */
  REAL_ESTATE_AND_LAND_ASSESSMENT = 10,
  /** 资产评估 */
  ASSETS_APPRAISAL = 20,
  /** 其他评估咨询 */
  OTHER_ASSESSMENT_CONSULTING = 30,
}

// 业务领域显示名称映射
export const BusinessLinesNames: Record<number, string> = {
  [BusinessLines.NULL]: '未定义',
  [BusinessLines.REAL_ESTATE_AND_LAND_ASSESSMENT]: '房地产及土地评估',
  [BusinessLines.ASSETS_APPRAISAL]: '资产评估',
  [BusinessLines.OTHER_ASSESSMENT_CONSULTING]: '其他评估咨询',
};

// 业务领域选项（用于下拉选择）
export const BusinessLinesOptions = [
  { value: BusinessLines.REAL_ESTATE_AND_LAND_ASSESSMENT, label: BusinessLinesNames[BusinessLines.REAL_ESTATE_AND_LAND_ASSESSMENT] },
  // { value: BusinessLines.ASSETS_APPRAISAL, label: BusinessLinesNames[BusinessLines.ASSETS_APPRAISAL] },
  // { value: BusinessLines.OTHER_ASSESSMENT_CONSULTING, label: BusinessLinesNames[BusinessLines.OTHER_ASSESSMENT_CONSULTING] },
];

const getBusinessLinePrefix = (businessLine: number | string | null | undefined): number | undefined => {
  if (businessLine === null || businessLine === undefined || businessLine === '' || businessLine === BusinessLines.NULL) {
    return undefined;
  }
  const n = Number(businessLine);
  if (Number.isNaN(n) || n === BusinessLines.NULL) {
    return undefined;
  }
  return n;
};

export const getBusinessTypeLine = (businessType: number | null | undefined): number | undefined => {
  if (businessType === null || businessType === undefined || businessType === BusinessType.NULL) {
    return undefined;
  }
  const linePrefix = Math.floor(Number(businessType) / 100);
  return Number.isNaN(linePrefix) ? undefined : linePrefix;
};

export const isBusinessTypeMatchedBusinessLine = (
  businessType: number | null | undefined,
  businessLine: number | null | undefined,
): boolean => {
  const linePrefix = getBusinessLinePrefix(businessLine);
  if (linePrefix === undefined) {
    return false;
  }
  return getBusinessTypeLine(businessType) === linePrefix;
};

export const getBusinessTypeOptionsByLine = (businessLine: number | string | null | undefined) => {
  const linePrefix = getBusinessLinePrefix(businessLine);
  if (linePrefix === undefined) {
    return [];
  }
  return BusinessTypeOptions.filter(option => getBusinessTypeLine(option.value) === linePrefix);
};

export const normalizeBusinessTypeByLine = (
  businessLine: number | null | undefined,
  businessType: number | null | undefined,
): number | undefined => {
  if (businessType === null || businessType === undefined) {
    return undefined;
  }
  return isBusinessTypeMatchedBusinessLine(businessType, businessLine) ? businessType : undefined;
};

/** 是否为个贷押品业务（1001 / 2003） */
export const isPersonalLoan = (code: number | string | null | undefined): boolean => {
  if (code === null || code === undefined || code === '') return false;
  const n = Number(code);
  return n === BusinessType.PERSONAL_LOAN_BUSINESS || n === BusinessType.PERSONAL_ASSET_BUSINESS;
};

// 业务来源枚举
export enum BusinessSource {
  /** 建行委托 */
  CCB_ENTRUST = 'CCB_ENTRUST',
  /** 外部委托 */
  EXTERNAL_ENTRUST = 'EXTERNAL_ENTRUST',
  /** 个人委托 */
  PERSONAL_ENTRUST = 'PERSONAL_ENTRUST',
}

// 业务来源显示名称映射
export const BusinessSourceNames: Record<BusinessSource, string> = {
  [BusinessSource.CCB_ENTRUST]: '建行委托',
  [BusinessSource.EXTERNAL_ENTRUST]: '外部委托',
  [BusinessSource.PERSONAL_ENTRUST]: '个人委托',
};

// 业务来源选项（用于下拉选择）
export const BusinessSourceOptions = [
  { value: BusinessSource.CCB_ENTRUST, label: BusinessSourceNames[BusinessSource.CCB_ENTRUST] },
  { value: BusinessSource.EXTERNAL_ENTRUST, label: BusinessSourceNames[BusinessSource.EXTERNAL_ENTRUST] },
  { value: BusinessSource.PERSONAL_ENTRUST, label: BusinessSourceNames[BusinessSource.PERSONAL_ENTRUST] },
];

// 工具函数：根据业务类型值获取显示名称
export const getBusinessTypeName = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {
    return BusinessTypeNames[BusinessType.NULL];
  }
  return BusinessTypeNames[value as BusinessType] || BusinessTypeNames[BusinessType.NULL];
};

// 工具函数：根据业务领域值获取显示名称
export const getBusinessLinesName = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {
    return BusinessLinesNames[BusinessLines.NULL];
  }
  return BusinessLinesNames[value as BusinessLines] || BusinessLinesNames[BusinessLines.NULL];
};

// 工具函数：根据业务来源值获取显示名称
export const getBusinessSourceName = (value: string | null | undefined): string => {
  if (!value) {
    return '-';
  }
  return BusinessSourceNames[value as BusinessSource] || value;
};

/**
 * 净值方案区县维度开关。
 * 后端区县匹配逻辑就绪后改为 true，即可恢复表单/列表区县入口及 page、upsert 的 districtCode 入参。
 */
export const NET_WORTH_PLAN_DISTRICT_ENABLED = true;

// 净值名称枚举
export enum NetWorthName {
  /** 未定义 */
  NULL = -1,
  /** 抵押净值1 */
  NET_WORTH_PLAN_ONE = 'NET_WORTH_PLAN_ONE',
  /** 抵押净值2 */
  NET_WORTH_PLAN_TWO = 'NET_WORTH_PLAN_TWO',
  /** 抵押净值3 */
  NET_WORTH_PLAN_THREE = 'NET_WORTH_PLAN_THREE',
}

// 净值名称显示名称映射
export const NetWorthNameNames: Record<NetWorthName, string> = {
  [NetWorthName.NULL]: '未定义',
  [NetWorthName.NET_WORTH_PLAN_ONE]: '抵押净值1',
  [NetWorthName.NET_WORTH_PLAN_TWO]: '抵押净值2',
  [NetWorthName.NET_WORTH_PLAN_THREE]: '抵押净值3',
};

// 净值名称选项（用于下拉选择）
export const NetWorthNameOptions = [
  { value: NetWorthName.NET_WORTH_PLAN_ONE, label: NetWorthNameNames[NetWorthName.NET_WORTH_PLAN_ONE] },
  { value: NetWorthName.NET_WORTH_PLAN_TWO, label: NetWorthNameNames[NetWorthName.NET_WORTH_PLAN_TWO] },
  { value: NetWorthName.NET_WORTH_PLAN_THREE, label: NetWorthNameNames[NetWorthName.NET_WORTH_PLAN_THREE] },
];

/**
 * 任务类型枚举
 */
export enum TaskTypeEnum {
  /**
   * 新增任务
   */
  NEW = "NEW",

  /**
   * 重估任务
   */
  REVALUATION = "REVALUATION"
}

// 任务类型显示名称映射
export const TaskTypeNames: Record<TaskTypeEnum, string> = {
  [TaskTypeEnum.NEW]: '新增',
  [TaskTypeEnum.REVALUATION]: '重估',
};

// 任务类型选项（用于下拉选择）
export const TaskTypeOptions = [
  { value: TaskTypeEnum.NEW, label: TaskTypeNames[TaskTypeEnum.NEW] },
  { value: TaskTypeEnum.REVALUATION, label: TaskTypeNames[TaskTypeEnum.REVALUATION] },
];

/** 报告详情等只读场景：NEW→新增任务，REVALUATION→重估任务 */
export const TaskTypeDetailNames: Record<TaskTypeEnum, string> = {
  [TaskTypeEnum.NEW]: '新增',
  [TaskTypeEnum.REVALUATION]: '重估',
};

export function formatTaskTypeDetailDisplay(taskType?: string | null, empty = '-'): string {
  const code = taskType == null ? '' : String(taskType).trim();
  if (code && Object.prototype.hasOwnProperty.call(TaskTypeDetailNames, code)) {
    return TaskTypeDetailNames[code as TaskTypeEnum];
  }
  return code || empty;
}

/** 物业用途枚举（台账编辑页） */
export const PropertyUsageOptions = [
  { value: '住宅', label: '住宅' },
  { value: '写字楼', label: '写字楼' },
  { value: '商铺', label: '商铺' },
  { value: '公寓', label: '公寓' },
  { value: '别墅', label: '别墅' },
];

/** 特殊情况（任务/台账快照，与 isOnlineReport 独立） */
export enum SpecialSituation {
  OFFLINE_REPORT = 'OFFLINE_REPORT',
  ONLINE_REPORT = 'ONLINE_REPORT',
  WHITELIST = 'WHITELIST',
  OTHER_BANK_REFINANCING = 'OTHER_BANK_REFINANCING',
  INTERNAL_CONSULTATION = 'INTERNAL_CONSULTATION',
}

export const SpecialSituationNames: Record<SpecialSituation, string> = {
  [SpecialSituation.OFFLINE_REPORT]: '线下报告',
  [SpecialSituation.ONLINE_REPORT]: '线上报告',
  [SpecialSituation.WHITELIST]: '白名单',
  [SpecialSituation.OTHER_BANK_REFINANCING]: '他行转贷',
  [SpecialSituation.INTERNAL_CONSULTATION]: '行内会商',
};

export const SpecialSituationOptions = [
  { value: SpecialSituation.OFFLINE_REPORT, label: SpecialSituationNames[SpecialSituation.OFFLINE_REPORT] },
  { value: SpecialSituation.ONLINE_REPORT, label: SpecialSituationNames[SpecialSituation.ONLINE_REPORT] },
  { value: SpecialSituation.WHITELIST, label: SpecialSituationNames[SpecialSituation.WHITELIST] },
  { value: SpecialSituation.OTHER_BANK_REFINANCING, label: SpecialSituationNames[SpecialSituation.OTHER_BANK_REFINANCING] },
  { value: SpecialSituation.INTERNAL_CONSULTATION, label: SpecialSituationNames[SpecialSituation.INTERNAL_CONSULTATION] },
];

/** ProTable valueEnum：按枚举值精确筛选 */
export const SpecialSituationValueEnum = Object.fromEntries(
  SpecialSituationOptions.map(({ value, label }) => [value, { text: label }]),
) as Record<SpecialSituation, { text: string }>;

/** 优先接口中文名，空值展示为 - */
export const getSpecialSituationName = (
  value?: string | null,
  name?: string | null,
): string => {
  if (name != null && String(name).trim() !== '') {
    return String(name);
  }
  if (!value) {
    return '-';
  }
  return SpecialSituationNames[value as SpecialSituation] || '-';
};

/** 实际用途（与任务权属 actualUsedType、报告模板匹配 actualUse 一致） */
export const ActualUseOptions = [
  { value: '住宅', label: '住宅' },
  { value: '公寓', label: '公寓' },
  { value: '写字楼', label: '写字楼' },
  { value: '商铺', label: '商铺' },
  { value: '别墅', label: '别墅' },
];
